module.exports = __webpack_public_path__ + "img/组 2935.51d07de5.svg";